import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"

import { ApiStatus } from "./common"

export const defaultUrl = `${process.env.REACT_APP_BASE_API_URL || ""}/admin`

export interface GetWhimstayDescriptionData {
  id: null
  description: string
  isDefault: boolean
  remove: boolean
}

export interface GetWhimstayDescriptionByPmcIdResponseData {
  data: GetWhimstayDescriptionData
}

export interface GetWhimstayDescriptionByPmcIdResponse extends AxiosResponse {
  data: GetWhimstayDescriptionByPmcIdResponseData
}

export interface GetWhimstayDescriptionByPmcIdRequestData {
  pmcId: string
}

export interface GetWhimstayDescriptionByPmcIdRequest
  extends Partial<AxiosRequestConfig> {
  params: GetWhimstayDescriptionByPmcIdRequestData
}

export function getWhimstayDescriptionByPmcId(
  {
    params,
    method = "get",
    url = `${defaultUrl}/desc`,
    ...config
  }: GetWhimstayDescriptionByPmcIdRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetWhimstayDescriptionByPmcIdResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<GetWhimstayDescriptionByPmcIdResponse>
}

export interface UpdateWhimstayPropertyDescResponseData {
  time: string
  apiStatus: ApiStatus
  status?: number
  message?: string
  errorCode?: number
  errorMessage?: string
}

export interface UpdateWhimstayPropertyDescResponse extends AxiosResponse {
  data: UpdateWhimstayPropertyDescResponseData
}

export interface UpdateWhimstayPropertyDescRequestData {
  description: string
  isDefault: boolean
}

export interface UpdateWhimstayPropertyDescRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    pmcId: string
  }
  data: UpdateWhimstayPropertyDescRequestData
}

export function updateWhimstayPropertyDesc(
  {
    params,
    data,
    method = "post",
    url = `${defaultUrl}/update-desc`,
    ...config
  }: UpdateWhimstayPropertyDescRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<UpdateWhimstayPropertyDescResponse> {
  return axiosInstance({
    params,
    data,
    method,
    url,
    ...config,
  }) as Promise<UpdateWhimstayPropertyDescResponse>
}
